/* eslint-disable max-len */
import React from 'react';

const AddFile = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 16V2H9V9H16V10C16.7 10 17.37 10.13 18 10.35V6L12 0H2C0.89 0 0 0.89 0 2V16C0 16.5304 0.210714 17.0391 0.585786 17.4142C0.960859 17.7893 1.46957 18 2 18H10.35C10.13 17.37 10 16.7 10 16H2ZM11 1.5L16.5 7H11V1.5ZM20 15V17H17V20H15V17H12V15H15V12H17V15H20Z" fill="#6A2976" />
  </svg>
);

export default AddFile;
